import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import ThankYou from "@/pages/ThankYou";
import RegistrationConfirmed from "@/pages/RegistrationConfirmed";
import Cancel from "@/pages/Cancel";
import Admin from "@/pages/Admin";
import Unsubscribe from "@/pages/Unsubscribe";
import OrganizationInquiry from "@/pages/OrganizationInquiry";
import LabSender from "@/pages/LabSender";
import BuildLabFollowUp from "@/pages/BuildLabFollowUp";
import StudentCamp from "@/pages/StudentCamp";
import FundingReadiness from "@/pages/FundingReadiness";
import Shop from "@/pages/Shop";
import Library from "@/pages/Library";
import { SiteContentProvider } from "@/lib/siteContent";

function App() {
  return (
    <div className="App">
      <SiteContentProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/registration-confirmed" element={<RegistrationConfirmed />} />
          {/* Legacy success URL kept so any in-flight links still resolve */}
          <Route path="/success" element={<Navigate to="/registration-confirmed" replace />} />
          <Route path="/cancel" element={<Cancel />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/organization-inquiry" element={<OrganizationInquiry />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/lab-sender" element={<LabSender />} />
          <Route path="/build-lab-follow-up" element={<BuildLabFollowUp />} />
          <Route path="/student-camp" element={<StudentCamp />} />
          <Route path="/funding-readiness" element={<FundingReadiness />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/library/*" element={<Library />} />
        </Routes>
      </BrowserRouter>
      </SiteContentProvider>
      <Toaster
        theme="light"
        position="top-right"
        toastOptions={{
          style: { background: "#FFFFFF", border: "1px solid #EDEAE0", color: "#0A0A0A" },
        }}
      />
    </div>
  );
}

export default App;
